import { render, staticRenderFns } from "./MSA.vue?vue&type=template&id=2c7d07ce&"
import script from "./MSA.vue?vue&type=script&lang=js&"
export * from "./MSA.vue?vue&type=script&lang=js&"
import style0 from "./MSA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports